<template>
    <div class="avaContainer">
        <img class="avaAnimation" v-bind:src="animationPath" v-if="currentAnimation"/>
    </div>
</template>
<script>
    import Vue from 'vue';
    import { mapState, mapActions } from 'vuex';
    import animations from '../store/animations';
  
    export default {
        namespaced: true,
        name: 'Ava',
        data() {
            return {
                baseUrl: process.env.BASE_URL
            }
        },
        computed: {
            ...mapState({
                currentAnimation: state => state.ava.currentAnimation,
                animationPath() {
                    return this.baseUrl + 'ava/' + this.currentAnimation + '.gif';
                }
            })
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    h3 {
        margin: 40px 0 0;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    .avaContainer {
        display:flex;
        align-items:center;
        justify-content:center;
        float: left;
        width: 240px;
        height: 518px;
        background: #1D1D1D;
        border-right: 2px solid #030303;
        position: relative;
    }

    .avaAnimation {
        width:220px;
        height:420px;
    }
</style>
